export default __webpack_public_path__ + "static/media/is-greater-than.b42c0251.svg";